//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import FocusTrap from 'focus-trap-react';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
// import styles from '../../../welcome/client/signUp/index.scss';

//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Modal, Header, Form, Button, ButtonStyle } from '@cmp/common';
import { CreateAccountHeading } from '../../../welcome/client/signUp/';
import { StateIndicator } from '@cmp/common';
//------------------------------------------------------------------------------
// API -------------------------------------------------------------------------
import { signIn } from '@api/endpoints/post/auth';
import { loadProviders } from '@api/endpoints/get/providers';
import { createLoginLink } from '@api/endpoints/post/providers';

//------------------------------------------------------------------------------
// Helpers & Constants ---------------------------------------------------------
import { ResponseStatusCode } from '@helpers/constants/api';
import { STRIPE_STATUS } from '@helpers/constants/stripe';
//------------------------------------------------------------------------------
// Helpers ---------------------------------------------------------------------
import { verifyLogin } from '@helpers/gigya';
import { getValue, storeValue } from '@helpers/localStorage';
import { auth, deauth, withAuthUser } from '@helpers/auth';
import { updateStripeVerification, isRegistered } from '@helpers/account';
import { StoreConfigContext } from '@helpers/storeConfigContext';
//------------------------------------------------------------------------------
// Constants -------------------------------------------------------------------
import {
  AuthorizationStorageKey,
  SkipStripe,
  StripeRegistrationUrl,
  refCode,
  StripeStatus,
  IsAdminApproved,
  DisplayPendingModal,
} from '@helpers/constants/localStorage';
import { withTranslation } from 'react-i18next';

//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class Auth extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      stripeUrl: null,
      user: null,
      loading: true,
      pendingApproval: false,
    };
    this.verifyAccount = this.verifyAccount.bind(this);
    this.verifyStripe = this.verifyStripe.bind(this);
    this.mountTrap = this.mountTrap.bind(this);
    this.unmountTrap = this.unmountTrap.bind(this);
  }

  componentDidMount() {
    let that = this;
    const { __authUser } = this.props;

    verifyLogin(__authUser).then(that.verifyAccount).catch(deauth);
    this.mountTrap();
  }
  mountTrap() {
    this.setState({ activeTrap: true });
  }
  unmountTrap() {
    this.setState({ activeTrap: false });
  }

  verifyAccount(user) {
    const { history } = this.props;
    const pushState = { fromCallback: true };

    console.log('1. verifyAccount', user);

    if (!isRegistered(user)) {
      console.log('1.1 !isRegistered');

      history.push({
        pathname: '/registration',
        state: pushState,
      });
    } else {
      this.verifyAuthenticationTokenAndStripe(user);
    }
  }

  verifyAuthenticationTokenAndStripe(user) {
    let that = this;
    const { history } = this.props;
    const authorizationToken = getValue(AuthorizationStorageKey);

    console.log('2. verifyAuthenticationTokenAndStripe');

    if (authorizationToken) {
      console.log('2.1 authorizationToken');
      this.verifyStripe(user);
    } else {
      console.log('2.2 !authorizationToken');

      signIn(user)
        .then(({ headers }) => {
          auth({}, true, headers);
          that.verifyStripe(user);
        })
        .catch(({ response }) => {
          if (response && response.status === ResponseStatusCode.BadRequest) {
            that.setState({ pendingApproval: true, loading: false });
          } else {
            deauth();
          }
        });
    }
  }
  async verifyStripe(user) {
    const that = this;
    const idealUser = user || this.props.__authUser;
    const { data } = idealUser;

    const {
      storeConfig: { payoutOption },
      featureFlags: { stripePayouts },
    } = this.context;

    const stripeEnabled = typeof stripePayouts === 'undefined' || stripePayouts;
    const hasPayoutOption = typeof payoutOption === 'undefined' || payoutOption;
    this.setState({ user: idealUser });

    console.log('4. verifyStripe');

    try {
      const data = await loadProviders();

      console.log('4.1 loadProviders', data);

      const {
        data: { stripeConnected, referralCode, isApproved, stripeStatus },
      } = data || {};
      storeValue(refCode, referralCode);
      storeValue(StripeStatus, stripeStatus);

      //IsAdminApproved to be used later in flow
      if (
        isApproved == true &&
        (stripeEnabled ? stripeStatus === STRIPE_STATUS.ACTIVE : true)
      ) {
        storeValue(IsAdminApproved, true);
      } else {
        storeValue(IsAdminApproved, false);
        storeValue(DisplayPendingModal, true);
      }
      this.setState({ loading: false }); //replaces wholesaler logic.

      console.log('4.2.0 payout', hasPayoutOption);

      if (!stripeEnabled || !hasPayoutOption) {
        console.log(
          `4.2 Payout option (${
            hasPayoutOption ? hasPayoutOption : ''
          }) doesn't require Stripe`
        );
        that.setState({ stripeUrl: 'skip' });

        updateStripeVerification(true);

        console.log('4.2.1 End flow. Authenticate user:', idealUser.identities);
        auth(idealUser);
      } else {
        console.log('4.3 check if stripe connected');
        if (stripeConnected && stripeStatus == STRIPE_STATUS.ACTIVE) {
          updateStripeVerification(true);
          console.log(
            '4.3.1 End flow. Authenticate user:',
            idealUser.identities
          );
          auth(idealUser);
        } else {
          that.startStripeConnect(user);
        }
      }
    } catch (error) {
      console.error(error);
      that.setState({ error, loading: false });
    }
  }

  skipStripe(url) {
    storeValue(SkipStripe, true);
    storeValue(StripeRegistrationUrl, url);
  }

  startStripeConnect = (user) => {
    let that = this;
    const { storeConfig } = this.context;

    console.log('4. startStripeConnect');
    createLoginLink(user.data.email)
      .then(({ data }) => {
        if (!data) return;

        const { url } = data;
        that.setState({
          stripeUrl: url,
        });
      })
      .catch((err) => {
        console.log('Error On createLoginLink', err);
      });
  };

  errorComponent() {
    const { t } = this.props;
    return (
      <Form
        className={styles.Form}
        title={t('GenericErrorMessage')}
        subtitle={t('login_PleaseReloadPage')}
        additionalComponent={
          <Button className={styles.GoBack} onClick={deauth}>
            {t('login_GoBackToLogin')}
          </Button>
        }
      />
    );
  }

  loadingComponent() {
    const { t } = this.props;

    return (
      <Form className={styles.Form}>
        <StateIndicator loading minimal={false} />
      </Form>
    );
  }

  stripeComponent() {
    const { t } = this.props;
    const { stripeUrl, user } = this.state;
    const {
      featureFlags: { stripePayouts },
    } = this.context;
    const stripeEnabled = typeof stripePayouts === 'undefined' || stripePayouts;

    if (!stripeEnabled) {
      setTimeout(() => {
        this.skipStripe(stripeUrl);
        auth(user);
      }, 100);
      return this.loadingComponent();
    }

    return (
      <>
        <CreateAccountHeading className={styles.HeadingSection} />
        <div className={styles.StripeUnderlay} />
        <FocusTrap>
          <Modal.Base
            className={styles.StripeModal}
            onClose={() => {
              this.skipStripe(stripeUrl);
              auth(user);
            }}
          >
            <h2 className={styles.StripeTitle}>
              {t('login_WhereShouldDeposit')}
            </h2>
            <div className={styles.StripeSubTitle}>
              {t('login_WhereShouldDepositDescription')}
              <br />
              {t('login_ColgatePartneredWith')}{' '}
              {t('trust_arc_locale') != 'ja' ? (
                <a
                  href="https://stripe.com/about"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.Links}
                >
                  Stripe
                </a>
              ) : (
                <span>Stripe</span>
              )}{' '}
              {t('login_ColgatePartneredWithDescription')}
            </div>
            <div className={styles.ActionButtons}>
              <Button
                style={ButtonStyle.Outlined}
                onClick={() => {
                  this.skipStripe(stripeUrl);
                  auth(user);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    this.skipStripe(stripeUrl);
                    auth(user);
                  }
                }}
              >
                {t('login_CreateStripeAccountLater')}
              </Button>

              <Button
                style={ButtonStyle.Filled}
                onClick={() => (window.location = stripeUrl)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') window.location = stripeUrl;
                }}
              >
                {t('login_CreateStripeAccount')}
              </Button>
            </div>
          </Modal.Base>
        </FocusTrap>
      </>
    );
  }

  idealComponent() {
    const { stripeUrl, error, loading } = this.state;

    if (loading) {
      return this.loadingComponent();
    } else if (stripeUrl) {
      return this.stripeComponent();
    } else if (error) {
      return this.errorComponent();
    }
    return this.loadingComponent();
  }

  render() {
    const { pendingApproval, stripeUrl } = this.state;
    const componentClasses = classNames(styles.Auth);

    return (
      <div className={componentClasses}>
        <Header pendingApproval={pendingApproval} />
        <div className={styles.Content}>{this.idealComponent()}</div>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withAuthUser(withTranslation()(Auth));
Auth.contextType = StoreConfigContext;
const CreateLoginHeadingComponent = withTranslation()(({ t, className }) => {
  return (
    <div className={className || styles.HeadingSection}>
      <div>
        <a href="/">&lt;</a>
        <a href="/">{t('header_title')}</a>
      </div>
      <h2>{t('login_CompleteAccountDetails')}</h2>
    </div>
  );
});
